import { Alert } from "@mui/material";
import React from "react";

type MemberCreatedInvoicePersistenceNoticeProps = {
  /** Label of the send button when the preview shows it (for example "Send Invoice"). */
  sendButtonLabel?: string;
};

const MemberCreatedInvoicePersistenceNotice = ({
  sendButtonLabel,
}: MemberCreatedInvoicePersistenceNoticeProps) => (
  <Alert severity="info" className="max-w-xl text-left">
    The invoice is saved. Closing this preview does not email it to the
    member, and it does not change the invoice status.
    {sendButtonLabel ? ` To email it now, select ${sendButtonLabel}.` : ""}
  </Alert>
);

export default MemberCreatedInvoicePersistenceNotice;
